import { useEffect, useState } from 'react';

import { getSyncProgressState, subscribeSyncProgress } from './syncProgressState';
import { SyncProgressState } from './syncProgressTypes';

/** React binding for the module-level sync progress store. */
export function useSyncProgress(): SyncProgressState {
  const [state, setState] = useState<SyncProgressState>(getSyncProgressState);

  useEffect(() => subscribeSyncProgress(setState), []);

  return state;
}
